const Request = require('./BaseRequest')
const GodaddyGraph = require('../graph/GodaddyGraph')

module.exports = class GodaddyRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new GodaddyGraph(this.apiDomain)
    }

    async domainAvailable(domain)
    {
        let args = {domain: domain}
        let { type, query } = this.graph.domainAvailableQuery([
            'available', 'currency', 'definitive', 'domain', 'period', 'price'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async domainSuggest(domain)
    {
        let args = {domain: domain}
        let { type, query } = this.graph.domainSuggestQuery([
            'domains'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }
}